
import { mapGetters } from "vuex";
import AccountSearch from "vue-material-design-icons/AccountSearch.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";

export default {
  name: "RiscoClienteGrupo",
  components: {
    AccountSearch,
    InformationOutline,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carregando: false,
      erro: "",
      consulta: null,
      empresaDetalheId: null,
      abaAtiva: 0,
      carregandoCompras: false,
      erroCompras: "",
      compras: null,
      filtroHistorico: "",
    };
  },
  computed: {
    ...mapGetters(["empresaContexto", "empresas"]),
    ajudaScoreId() {
      return `ajuda-score-cliente-${this._uid}`;
    },
    documento() {
      return String(this.cliente?.cnpj_cpf || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    empresasDoGrupo() {
      const grupoId = Number(this.empresaContexto?.id_grupo_empresa || 0);

      return (this.empresas || []).filter(
        (empresa) => Number(empresa.id_grupo_empresa || 0) === grupoId
      );
    },
    documentoValido() {
      return /^\d{11}$/.test(this.documento) || /^[A-Z0-9]{14}$/.test(this.documento);
    },
    podeConsultar() {
      return (
        Number(this.cliente?.id_pessoa || 0) > 0 &&
        this.documentoValido &&
        Number(this.empresaContexto?.id_grupo_empresa || 0) > 0 &&
        this.empresasDoGrupo.length > 1
      );
    },
    historicoFiltrado() {
      const historico = this.compras?.historico || [];
      const termo = String(this.filtroHistorico || "")
        .toLocaleLowerCase("pt-BR")
        .trim();

      if (!termo) return historico;

      return historico.filter((item) => {
        const conteudo = [
          item.empresa?.nome,
          item.produto?.descricao,
          item.produto?.referencia,
          item.produto?.cod_barras,
          item.produto?.codigo,
          item.numero_nota,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase("pt-BR");

        return conteudo.includes(termo);
      });
    },
  },
  watch: {
    "cliente.id_pessoa"() {
      this.consulta = null;
      this.erro = "";
      this.empresaDetalheId = null;
      this.abaAtiva = 0;
      this.compras = null;
      this.erroCompras = "";
      this.filtroHistorico = "";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.abrirPeloAtalho);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.abrirPeloAtalho);
  },
  methods: {
    abrirPeloAtalho(event) {
      if (event.key !== "F8" || event.repeat || !this.podeConsultar) return;

      event.preventDefault();
      event.stopPropagation();
      this.abrir();
    },
    async abrir() {
      this.abaAtiva = 0;
      this.$refs.modal.show();
      await this.consultar();
    },
    async consultar() {
      this.carregando = true;
      this.erro = "";

      try {
        const response = await this.$http.post("/empresa/grupo/clientes/risco", {
          id_pessoa: Number(this.cliente.id_pessoa),
        });
        this.consulta = response.data.data;
      } catch (error) {
        this.consulta = null;
        this.erro =
          error?.response?.data?.message ||
          "Não foi possível consultar o risco financeiro agora.";
      } finally {
        this.carregando = false;
      }
    },
    aoAlterarAba(indice) {
      if (Number(indice) > 0) {
        this.consultarCompras();
      }
    },
    async consultarCompras(forcar = false) {
      if ((this.compras && !forcar) || this.carregandoCompras) return;

      this.carregandoCompras = true;
      this.erroCompras = "";

      try {
        const response = await this.$http.post("/empresa/grupo/clientes/compras", {
          id_pessoa: Number(this.cliente.id_pessoa),
        });
        this.compras = response.data.data;
      } catch (error) {
        this.compras = null;
        this.erroCompras =
          error?.response?.data?.message ||
          "Não foi possível consultar as compras do cliente agora.";
      } finally {
        this.carregandoCompras = false;
      }
    },
    alternarDetalhes(empresaId) {
      this.empresaDetalheId = this.empresaDetalheId === empresaId ? null : empresaId;
    },
    classeScore(nivel) {
      return {
        EXCELENTE: "text-success",
        BOM: "text-primary",
        REGULAR: "text-warning",
        BAIXO: "text-danger",
      }[nivel];
    },
    classeLabel(nivel) {
      return {
        EXCELENTE: "label-light-success",
        BOM: "label-light-primary",
        REGULAR: "label-warning",
        BAIXO: "label-danger",
      }[nivel];
    },
    varianteScore(nivel) {
      return {
        EXCELENTE: "success",
        BOM: "primary",
        REGULAR: "warning",
        BAIXO: "danger",
      }[nivel];
    },
    classeSituacaoRecompra(situacao) {
      return {
        RECOMPRA_PROVAVEL: "label-light-success",
        PROXIMA: "label-warning",
        PREVISTA: "label-light-primary",
      }[situacao];
    },
    classeTipoMovimento(origem) {
      return {
        NFE: "label-light-success",
        NFCE: "label-light-success",
        PRE_VENDA: "label-light-info",
        PEDIDO: "label-light-primary",
        ORCAMENTO: "label-light-warning",
        OS: "label-light-dark",
      }[origem] || "label-light";
    },
    identificacaoProduto(produto) {
      if (produto.cod_barras) return `Cód. barras: ${produto.cod_barras}`;
      if (produto.referencia) return `Referência: ${produto.referencia}`;
      if (produto.codigo) return `Código: ${produto.codigo}`;
      return "Sem identificação adicional";
    },
    chaveSugestao(sugestao) {
      const produto = sugestao.produto || {};
      return [produto.cod_barras, produto.referencia, produto.codigo, produto.descricao]
        .filter(Boolean)
        .join("-");
    },
    chaveHistorico(item) {
      return `${item.origem}-${item.id_documento || item.id_nfe}-${item.item_indice}-${this.chaveSugestao(item)}`;
    },
    formatarQuantidade(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    },
    formatarMoeda(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatarData(valor) {
      if (!valor) return "—";
      const partes = String(valor).slice(0, 10).split("-");
      return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor;
    },
    formatarDocumento(valor) {
      const documento = String(valor || "");
      if (/^\d{11}$/.test(documento)) {
        return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (/^\d{14}$/.test(documento)) {
        return documento.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
      return documento;
    },
  },
};
